module.exports = __webpack_public_path__ + "static/img/297_TO8_1931.1cda01f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/297_TO8_1931.jpg
// module id = fnYr
// module chunks = 0